import {Component} from "@angular/core";

@Component({
    selector: "fui-pops",
    templateUrl: "./pops.component.html",
    standalone: false
})
export class FUIPopsComponent {
    constructor() {
    }
}
